import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------
const WhiteStyledTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    color: 'white',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'white',
  },
  '& .MuiInputBase-input': {
    color: 'white',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'rgba(255, 255, 255, 0.3)',
    },
    '&:hover fieldset': {
      borderColor: 'white',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'white',
    },
  },
  '& .MuiAutocomplete-endAdornment': {
    color: 'white',
  },
});

export default function RHFAutocompleteBasic({
  label,
  // size,
  placeholder,
  handleChangeValue,
  handleChangeSearch,
  options,
  multiple,
  // ...other
}) {
  return (
    <Autocomplete
      className={multiple ? 'auto-tag-input-2' : 'RHFAutocompleteBasic'}
      id="country-select-demo"
      options={options} // to give options(array)
      autoHighlight
      size="small" // size
      multiple={multiple}
      getOptionLabel={(option) => option?.label} // ensure label is given correctly
      onChange={handleChangeValue} // to get selected or change value
      renderOption={(props, option) => (
        <Box
          key={option?.value} // ensure that `value` is unique for each option
          component="li"
          sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          {option?.label}
        </Box>
      )}
      // renderInput={(params) => (
      //   <TextField
      //     {...params}
      //     label={label} // label
      //     placeholder={placeholder} // placeholder
      //     onChange={handleChangeSearch} //
      //     inputProps={{
      //       ...params.inputProps,
      //       autoComplete: '',
      //     }}
      //   />
      renderInput={(params) => (
        <WhiteStyledTextField
          {...params}
          label={label}
          placeholder={placeholder}
          onChange={handleChangeSearch}
          inputProps={{
            ...params.inputProps,
            autoComplete: '',
          }}
        />
      )}
    />
  );
}

RHFAutocompleteBasic.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  helperText: PropTypes.node,
  placeholder: PropTypes.string,
  size: PropTypes.string,
  handleChangeValue: PropTypes.func,
  handleChangeSearch: PropTypes.func,
  options: PropTypes.array,
  multiple: PropTypes.bool,
};
